<div class="p-d-flex p-dir-col log-in-layout">
    <sigv-login-header></sigv-login-header>
    <main class="log-in-bg p-d-flex p-flex-column p-jc-center" [style.background-image]="'url(' + blobUrlBg +  ')'">
        <div class="log-in-area p-d-flex p-flex-row">
            <div class="log-in-desc p-flex-column p-ai-center" [style.background-image]="'url(' + blobUrlLogin + ')'">
                <!-- <p>Reset Account Password</p> -->
                <img src="./assets/images/header-logo-holding.svg" alt="" />
                <!-- <article>
          {{ "Login.Description" | translate }}
        </article> -->
            </div>
            <div class="log-in-input forget-in-input">
                <div style="width: 80%;">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <p-steps [model]="items" [activeIndex]="currentStepIndex"></p-steps>
                            <div class="step-container" *ngIf="currentStepIndex === 0">
                                <h2>OTP shipping type</h2>
                                <div class="p-d-flex">
                                    <div class="p-field-radiobutton p-mr-5" *ngIf="otpShowEmail">
                                        <p-radioButton value="Email" name="type" [(ngModel)]="otpType"></p-radioButton>
                                        <label for="type1">
                                            {{ "ForgotPassword.Email" | translate }}
                                        </label>
                                    </div>
                                    <div class="p-field-radiobutton" *ngIf="otpShowPhone">
                                        <p-radioButton value="SMS" name="type" [(ngModel)]="otpType"></p-radioButton>
                                        <label for="type2">
                                            {{ "ForgotPassword.PhoneNo" | translate }}
                                        </label>
                                    </div>
                                </div>
                                <div class="p-d-flex p-jc-center">
                                    <button pButton type="button" label="Next" class="p-content-button"
                                        (click)="goNextStep()"></button>
                                </div>
                            </div>
                            <div class="step-container" *ngIf="currentStepIndex === 1">
                                <h2>OTP Enter</h2>
                                <div class="p-field">
                                    <input id="otp" name="otp" type="text" autocomplete="off" [placeholder]="'OTP'"
                                        pInputText [(ngModel)]="otp" [required]="true" />
                                </div>

                                <div class="p-d-flex p-jc-center">
                                    <button pButton type="button" label="Previous"
                                        class="p-button-secondary p-content-button p-mr-2"
                                        (click)="goBackStep()"></button>
                                </div>
                            </div>


                            <div class="p-field p-d-flex p-jc-center" *ngIf="currentStepIndex==1">
                                <button pButton type="button" label="Submit" class="p-button-secondary p-content-button"
                                    (click)="checkOTP()"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>
    <app-footer></app-footer>
</div>

<p-toast position="top-right"></p-toast>